export enum EffectTypes {
    TRANSFORM = 'TRANSFORM',
    CLIP = 'CLIP',
    DROPSHADOW = 'DROPSHADOW',
    BLUR = 'BLUR',
    OPACITY = 'OPACITY',
    MOTIONBLUR = 'MOTIONBLUR',
}
